import { ArticlePage, articleMeta, type ArticleData } from '@/site/article'

const article: ArticleData = {
  path: '/blog/ai-agent-chy-administrator',
  lead:
    'Питання «замінить чи не замінить» поставлене не так. Корисніше подивитися, які задачі адміністратора агент робить краще, де людина незамінна, і порахувати вигоду на своїх цифрах.',
  sections: [
    {
      h2: 'Що насправді робить адміністратор',
      blocks: [
        'Якщо розписати день адміністратора салону, клініки чи сервісу, телефон виявиться лише частиною роботи. Ще є зустріч клієнтів, оплата, нагадування, конфлікти, допомога майстрам, порядок на рецепції. А самі телефонні розмови різні:',
        {
          list: [
            'однакові питання: ціна, графік, адреса, чи є вільний час;',
            'запис і перенесення;',
            'складні розмови: скарга, нестандартний запит, клієнт, який вагається.',
          ],
        },
        'Перші два типи складають помітну частину дзвінків, і саме їх найпростіше передати агенту.',
      ],
    },
    {
      h2: 'Де AI-агент сильніший',
      blocks: [
        {
          list: [
            'Доступність. Агент відповідає з першого гудка вночі, у вихідні і тоді, коли адміністратор розраховує клієнта.',
            'Кілька дзвінків одночасно. У години пік ніхто не чекає на лінії.',
            'Однакова якість. Агент не втомлюється до вечора, не забуває уточнити телефон і не плутає ціни, якщо вони правильні в базі знань.',
            'Усе записано. Кожна розмова збережена й розшифрована, заявка створюється автоматично.',
            'Масштаб. Друга філія чи рекламна кампанія не потребують ще одного найму.',
          ],
        },
      ],
    },
    {
      h2: 'Де без людини не обійтися',
      blocks: [
        {
          list: [
            'Емоційні розмови: скарга, конфлікт, клієнт, якого треба заспокоїти.',
            'Продаж складних послуг, де рішення залежить від довіри й деталей.',
            'Усе, що відбувається офлайн: зустріти, розрахувати, допомогти.',
            'Ситуації, яких немає в жодних інструкціях.',
          ],
        },
        'Тому розумна схема не «агент замість адміністратора», а «агент бере телефонну рутину, адміністратор бере людей». Агент передає людині все, що потребує людини, а людина перестає розриватися між клієнтом на рецепції і дзвінком.',
      ],
    },
    {
      h2: 'Як порахувати вигоду на своїх цифрах',
      blocks: [
        'Середніх цифр «по ринку» тут не буде: про ваш бізнес вони мало що кажуть. Порахуйте три речі.',
        {
          steps: [
            { title: 'Скільки дзвінків ви втрачаєте', text: 'Кількість пропущених дзвінків за місяць, разом з вечорами й вихідними. Як це перевірити, описано в [окремій статті](/blog/skilky-dzvinkiv-vy-propuskayete).' },
            { title: 'Скільки коштує втрачений дзвінок', text: 'Помножте пропущені дзвінки на частку тих, хто зазвичай стає клієнтом, і на середній чек. Калькулятор з повзунками є [на головній сторінці](/#problem).' },
            { title: 'Скільки коштує агент', text: 'Абонплата за кабінет плюс хвилини розмов, тарифи на сторінці [цін](/tsiny). Хвилини рахуйте за фактом: середня тривалість дзвінка помножена на кількість дзвінків, які прийматиме агент.' },
          ],
        },
        'Якщо втрачені клієнти за місяць коштують більше, ніж агент, рішення очевидне. Якщо менше, агент усе одно може мати сенс заради вечорів і вихідних або щоб адміністратор більше уваги приділяв людям на рецепції.',
      ],
    },
    {
      h2: 'Як перевірити без ризику',
      blocks: [
        'Нічого не потрібно перебудовувати. Почніть з неробочого часу: агент приймає дзвінки лише ввечері й у вихідні, а вдень усе як раніше. За тиждень-два ви побачите в кабінеті, скільки дзвінків прийшло, про що питали і скільки заявок з’явилось. Далі вирішуєте на фактах: розширювати, змінювати чи відмовитися.',
        'Для цього є [безкоштовний пілот](/#pilot): налаштуємо агента разом з вами і подивимось на реальних дзвінках.',
      ],
    },
  ],
  faq: [
    {
      q: 'Чи можна звільнити адміністратора?',
      a: 'Ми не радимо так ставити питання. Агент знімає з людини телефонну рутину, але зустріти клієнта, вирішити конфлікт чи продати складну послугу краще вміє людина. Агент дає адміністратору змогу працювати з людьми, а не з телефоном.',
    },
    {
      q: 'Що, якщо агент помилиться?',
      a: 'Кожна розмова записана й розшифрована, тож помилку легко знайти й виправити базу знань чи інструкції агента. На старті варто переглядати записи щодня.',
    },
  ],
  related: ['/funktsii/ai-agent-dlya-dzvinkiv', '/blog/skilky-dzvinkiv-vy-propuskayete', '/dlya/saloniv-krasy', '/dlya/stomatologii'],
}

export const meta = articleMeta(article)

export default function Post() {
  return <ArticlePage article={article} />
}
